import api from './api';
import config from './config';

//export default api;
const plugin = {
    install: function (Vue) {
        Vue.prototype.$Api = api;
        Vue.prototype.$Config = config;
    }
};

export default plugin


// WEBPACK FOOTER //
// ./src/api/index.js